import { gql } from "apollo-boost";

export const GET_FABRICS = gql`
query Fabrics($where: FabricWhereInput) {
  fabrics(where: $where) {
    total
    data {
      id
      name
      price
      originPrice
      image
      imageString
      shop {
        id
        name
      }
      isDeleted
      createdAt
      updatedAt
      note
    }
  }
}
`
